(function () {
  // Avoid double init across PJAX / theme sections
  if (window.__nrVideoInit) return;
  window.__nrVideoInit = true;

  function enhanceBlock(root) {
    if (!root || root.dataset.nrVideoEnhanced === '1') return;

    var coverBtn = root.querySelector('.nr-video__cover');
    var player = root.querySelector('.nr-video__player');
    var videoId = root.getAttribute('data-video-id');

    if (!coverBtn || !player || !videoId) return;

    root.dataset.nrVideoEnhanced = '1';

    // Hover effects
    coverBtn.addEventListener('mouseenter', function () {
      var img = coverBtn.querySelector('img');
      var hover = coverBtn.querySelector('.nr-video__hover');
      var circle = coverBtn.querySelector('span > span');
      if (img) img.style.transform = 'scale(1.02)';
      if (hover) hover.style.opacity = '1';
      if (circle) circle.style.background = 'rgba(0,0,0,.72)';
    });

    coverBtn.addEventListener('mouseleave', function () {
      var img = coverBtn.querySelector('img');
      var hover = coverBtn.querySelector('.nr-video__hover');
      var circle = coverBtn.querySelector('span > span');
      if (img) img.style.transform = 'scale(1)';
      if (hover) hover.style.opacity = '0';
      if (circle) circle.style.background = 'rgba(0,0,0,.62)';
    });

    // Click to load iframe (autoplay + fullscreen)
    coverBtn.addEventListener('click', function () {
      if (player.dataset.loaded === '1') return;

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
      iframe.title = coverBtn.getAttribute('aria-label') || 'YouTube video player';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      iframe.setAttribute('allowfullscreen', '');

      iframe.style.position = 'absolute';
      iframe.style.top = '0';
      iframe.style.left = '0';
      iframe.style.width = '100%';
      iframe.style.height = '100%';

      player.appendChild(iframe);
      player.style.display = 'block';
      coverBtn.style.display = 'none';
      player.dataset.loaded = '1';
    });
  }

  function enhanceAll() {
    document.querySelectorAll('.nr-video').forEach(enhanceBlock);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  // In case the theme swaps content dynamically
  document.addEventListener('shopify:section:load', enhanceAll);
})();